<template>
    <v-dialog v-model="dialog" @keydown.esc="close" scrollable max-width="600" transition="dialog-bottom-transition">
        <v-card v-if="point">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ point.expert }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="text-center pa-8">
                <div class="text-left">
                    <div><strong>Último envio:</strong> {{ timestampFormatted }}</div>
                    <div class="mt-2"><strong>Coordenadas:</strong> {{ coordinatesFormatted }}</div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>    

export default {
    name: "PointDetails",

    props: {
        point: {
            required: true,
        },
        show: {
            required: true,
        },
    },

    computed: {
        dialog: {
            get: function () {
                return this.show
            },
            set: function (value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        },

        // formatted timestamp (uses $moment if available, fallback to Date)
        timestampFormatted() {
            if (!this.point || !this.point.createdAt) return "";
            if (this.$moment) {
                return this.$moment.utc(this.point.createdAt).local().format("DD/MM/YYYY HH:mm:ss");
            }
            return new Date(this.point.createdAt).toLocaleString();
        },

        // formatted coordinates (handles array or LatLng-like object)
        coordinatesFormatted() {
            if (!this.point || !this.point.cord) return "";
            const c = this.point.cord;
            // Array [lat, lng]
            if (Array.isArray(c) && c.length >= 2 && typeof c[0] === "number" && typeof c[1] === "number") {
                return `${c[0].toFixed(6)}, ${c[1].toFixed(6)}`;
            }
            // Leaflet LatLng object {lat, lng}
            if (c && typeof c.lat === "number" && typeof c.lng === "number") {
                return `${c.lat.toFixed(6)}, ${c.lng.toFixed(6)}`;
            }
            // Fallback: try index access or string
            if (c && typeof c[0] !== "undefined" && typeof c[1] !== "undefined") {
                return `${c[0]}, ${c[1]}`;
            }
            return String(c);
        },
    },

    methods: {
        close() {
            this.$emit("close");
        },
    },
};
</script>